import { rem } from 'polished'
import type { RefObject } from 'react'
import { useRef } from 'react'
import * as React from 'react'
import styled from 'styled-components'
import SearchInputTrigger from '../SearchInputTrigger'
import Content from './Content'
import SearchTravellersDropdown from './SearchTravellersDropdown'

const SearchTravellersInput = styled(SearchInputTrigger)`
  max-height: ${rem(50)};
`

interface Props {
  dropdownAnchorRef: RefObject<HTMLElement | null>
  dropdownPortaled?: boolean
  isToggled: boolean
  onTravellersToggle: (e: React.MouseEvent<HTMLButtonElement>) => void
  rooms: Array<App.Occupants>
  onRoomChange: (rooms: Array<App.Occupants>) => void
  onRoomsApply: () => void
  closeMenu: () => void
  isLastStep?: boolean
  error: boolean
  saleUnit?: string
  disabled?: boolean
  showAIGlow?: boolean
}

function SearchTravellersInputDesktop(props: Props) {
  const {
    dropdownAnchorRef,
    dropdownPortaled,
    rooms,
    onTravellersToggle,
    isToggled,
    onRoomChange,
    onRoomsApply,
    closeMenu,
    isLastStep,
    error,
    saleUnit,
    disabled,
    showAIGlow,
  } = props

  const inputRef = useRef<HTMLButtonElement>(null)

  return (
    <>
      <SearchTravellersInput
        ref={inputRef}
        onClick={onTravellersToggle}
        isToggled={isToggled}
        error={error}
        type="occupancy"
        disabled={!!disabled}
      >
        <Content showAIGlow={showAIGlow} />
      </SearchTravellersInput>

      <SearchTravellersDropdown
        anchorRef={dropdownAnchorRef}
        portaled={dropdownPortaled}
        triggerRef={inputRef}
        rooms={rooms}
        open={isToggled}
        onRoomChange={onRoomChange}
        onRoomsApply={onRoomsApply}
        onClose={closeMenu}
        isLastStep={isLastStep}
        saleUnit={saleUnit}
      />
    </>
  )
}

export default SearchTravellersInputDesktop
